function initMenu(menu) {
    document.querySelector('#nav .burger')
        .addEventListener('click', () => menu.classList.add('open'));
    document.querySelector('#nav .menu .burger')
        .addEventListener('click', () => menu.classList.remove('open'));
};

function initDropdowns(menu) {
    Array.from(menu.querySelectorAll('.menu-dropdown')).forEach((x) => {
        x.querySelector(':scope > .menu-item')
            .addEventListener('click', () => {
                x.classList.toggle('open');
            });
    });
};

function closeMenuWhenItemIsClicked(menu) {
    document.querySelectorAll('#nav .menu .menu-item').forEach((item) => {
        if (item.href.split('').includes('#')) {
            console.log('match');
            item.addEventListener('click', () => menu.classList.remove('open'));
        }
    });
};

function initDesktopScroll() {
    const section = document.querySelectorAll('.onepager-part');
    const sections = {};
    let i = 0;

    const headerHeight = document.getElementById('nav').offsetHeight;

    Array.prototype.forEach.call(section, (e) => {
        sections[e.id] = e.offsetTop - headerHeight - 150;
    });

    window.onscroll = function () {
        const scrollPosition = document.documentElement.scrollTop || document.body.scrollTop;

        for (i in sections) {
            if (sections[i] <= scrollPosition) {
                let currentActive = document.querySelector('.desktop-nav-item.is-active');
                if (currentActive) {
                    currentActive.classList.remove('is-active');
                }

                let newActive = document.querySelector(`.desktop-nav-item[href*=${i}]`);
                if (newActive) {
                    newActive.classList.add('is-active');
                }


                // replace lang links
                document.querySelectorAll(".lang-item").forEach((lang) => {
                    //console.log(lang)
                    const link = lang.getAttribute("href");
                    const linkparts = link.split("#");
                    lang.setAttribute("href", linkparts[0] + "#" + i);
                });
            }
        }
    };
}

export function initNavbar() {
    const menu = document.querySelector('#nav .menu');
    initMenu(menu);
    initDropdowns(menu);
    closeMenuWhenItemIsClicked(menu);
    initDesktopScroll();
}
